import React from "react";
import { useNavigate } from "react-router-dom";
import "./Hero.css";
import { FaArrowRight } from "react-icons/fa";

const Hero = () => {
  const navigate = useNavigate();

  return (
    <section className="heroX">
      <div className="heroX__wrap">
        {/* LEFT */}
        <div className="heroX__left">
          <div className="heroX__badge">
            <span className="dot" />
            Website + Marketing that actually converts
          </div>

          <h1 className="heroX__title">
            Turn visitors into <span>leads</span> and <span>sales</span> with a
            conversion-first website + performance growth.
          </h1>

          <p className="heroX__sub">
            We design fast, premium websites and run SEO + Ads to bring qualified
            traffic — then optimize landing pages, tracking, and funnels so the
            numbers improve every month.
          </p>

          <div className="heroX__cta">
            <button className="btn btn--primary" onClick={() => navigate("/contact")}>
              Get Free Audit <FaArrowRight />
            </button>

            <button className="btn btn--ghost" onClick={() => navigate("/strategies")}>
              Our Strategies
            </button>
          </div>

          <div className="heroX__trust">
            <div className="trustItem">
              <b>250+</b>
              <span>Projects shipped</span>
            </div>
            <div className="trustItem">
              <b>4.9/5</b>
              <span>Client rating</span>
            </div>
            <div className="trustItem">
              <b>ROI Focus</b>
              <span>Tracking + CRO</span>
            </div>
          </div>

          <div className="heroX__note">
            <span className="pulse" />
            No fluff — we show numbers: leads, CAC, ROAS, conversion rate.
          </div>
        </div>

        {/* RIGHT */}
        <div className="heroX__right">
          <div className="heroX__panel">
            <div className="heroX__panelTop">
              <div className="miniTitle">Growth Dashboard</div>
              <div className="miniTag">This month</div>
            </div>

            <div className="heroX__panelGrid">
              <div className="kpiCard">
                <p>Qualified Leads</p>
                <h3>
                  1,240 <span>+31%</span>
                </h3>
                <div className="spark" aria-hidden="true" />
              </div>

              <div className="kpiCard">
                <p>ROAS</p>
                <h3>
                  4.6x <span>+18%</span>
                </h3>
                <div className="spark" aria-hidden="true" />
              </div>

              <div className="kpiCard kpiCard--wide">
                <p>What you get</p>
                <div className="chips">
                  <span>High-speed Website</span>
                  <span>SEO Growth</span>
                  <span>Google Ads</span>
                  <span>Landing Pages</span>
                  <span>Tracking</span>
                  <span>Automation</span>
                </div>
              </div>
            </div>

            <div className="heroX__panelBottom">
              <div className="callout">
                <b>Want a plan for your business?</b>
                <span>We’ll share quick wins + a 30-day action roadmap.</span>
              </div>

              <button className="btn btn--mini" onClick={() => navigate("/contact")}>
                Book Call <FaArrowRight />
              </button>
            </div>

            <div className="heroX__glow" aria-hidden="true" />
            <div className="heroX__grid" aria-hidden="true" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;